import {
    ControlledInputField,
    ControlledInputFieldProps,
} from 'features/offline-reports/support-requests/components/support-requests-modals/components/inputs/controlled-input-field';
import React from 'react';
import { useUsersInAccountQuery } from 'hooks/queries/user/use-users-in-account-query';
import { useSelector } from 'react-redux';
import { selectIsSupportUser } from 'store/selectors/app-selectors';
import { EMAIL_INPUT_REGEX } from 'features/offline-reports/support-requests/consts';

export const SupportEmailInput = (props: Partial<ControlledInputFieldProps>) => {
    const isSupportUser = useSelector(selectIsSupportUser);
    const usersInAccountQuery = useUsersInAccountQuery({
        enabled: isSupportUser,
    });

    if (!isSupportUser) return null;

    return (
        <ControlledInputField
            name="email"
            label="Customer Email - For Ticket Creation"
            data-testid="request-new-location-email-input"
            asterix
            required
            type="email"
            rules={{
                pattern: {
                    value: EMAIL_INPUT_REGEX,
                    message: 'Invalid email address',
                },
                validate: (value) =>
                    usersInAccountQuery?.data?.data.some(({ email }) => email === value) ||
                    'Email is not linked to current account',
            }}
            {...props}
        />
    );
};
